// extracted by mini-css-extract-plugin
export var deliveryRow = "_rc-a";
export var fixedHeight = "_rc-4";
export var freightLogo = "_rc-9";
export var fullWidth = "_rc-3";
export var priceColumn = "_rc-5";
export var radioSelected = "_rc-7";
export var radioUnselected = "_rc-6";
export var selectedOption = "_rc-2";
export var selectedOptionContainer = "_rc-1";
export var selection = "_rc-0";
export var tallSkeletonText = "_rc-8";